import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';

const NAV = [
  { label: 'Services', href: '#services' },
  { label: 'Why ELEVA', href: '#why' },
  { label: 'Process', href: '#process' },
  { label: 'Work', href: '#portfolio' },
  { label: 'FAQ', href: '#faq' },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/70 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-40 flex items-center justify-between">
        <Logo size="sm" />

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, '-')}`}
              className="font-manrope text-sm text-white/70 hover:text-white transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="mailto:info@elevadigital.com.au?subject=Project%20Inquiry"
          data-testid="header-cta-mailto"
          className="hidden lg:inline-flex items-center gap-2 bg-brand-primary text-black font-manrope font-semibold uppercase tracking-wider text-xs px-6 py-3 hover:bg-white transition-colors duration-300"
        >
          Start a Project
          <span className="inline-block w-1.5 h-1.5 bg-black animate-pulse-dot" />
        </a>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10" data-testid="mobile-menu">
          <div className="px-6 py-8 flex flex-col gap-6">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
                className="font-outfit text-2xl tracking-tight text-white"
              >
                {item.label}
              </a>
            ))}
            <a
              href="mailto:info@elevadigital.com.au?subject=Project%20Inquiry"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-mailto"
              className="mt-4 inline-flex items-center justify-center bg-brand-primary text-black font-semibold uppercase tracking-wider text-sm px-6 py-4"
            >
              Start a Project
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
